declare namespace Clerk {
  export const session: {
    getToken: () => Promise<string | null>;
  };
}

function safeReadLocalStorage(key: string): string {
  if (typeof window === 'undefined' || !window.localStorage) {
    return '';
  }

  try {
    return window.localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

export async function getToken(): Promise<string> {
  try {
    if (typeof Clerk !== 'undefined' && Clerk.session?.getToken) {
      const token = await Clerk.session.getToken();
      if (token) {
        return token;
      }
    }
  } catch {
    // Fall through to other token sources.
  }

  try {
    if (typeof window !== 'undefined') {
      const token = await (window as any).Clerk?.session?.getToken?.();
      if (token) {
        return token;
      }
    }
  } catch {
    // Fall through to localStorage-based fallbacks.
  }

  return safeReadLocalStorage('better-auth-session-token') || safeReadLocalStorage('self-hosted-jwt') || '';
}
